export default {"src":"/_next/static/media/ribbon.e37e2630.svg","height":47,"width":38,"blurWidth":0,"blurHeight":0};